import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchApi } from "../config";

const ContactContext = createContext({ contact: null, loading: true, error: null });

export function ContactProvider({ children }) {
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    async function load() {
      try {
        const res = await fetchApi("get_contact_info.php");
        const item = res && Array.isArray(res.Info) && res.Info[0];
        if (!mounted) return;
        setContact(item || null);
      } catch (err) {
        if (!mounted) return;
        setError(err.message || "Failed to load contact info");
      } finally {
        if (!mounted) return;
        setLoading(false);
      }
    }
    load();
    return () => { mounted = false; };
  }, []);

  return (
    <ContactContext.Provider value={{ contact, loading, error }}>
      {children}
    </ContactContext.Provider>
  );
}

export function useContact() {
  return useContext(ContactContext);
}
